import { useStore } from '@nanostores/react';
import useIsHydrated from '@klaviyo-mkt/components/hooks/useIsHydrated';
import { $loggedIn, $isPartner } from '@academy/skilljar/stores/user';
import { $lastViewedResource, $lastViewedCollection } from '@academy/skilljar/stores/last-viewed-resource';
import { usePartnerProfileUrl } from '@academy/hooks/usePartnerProfileUrl';
import { Header } from '@klaviyo-mkt/components/organisms/header';
import { getAlertBarConfig } from './utils/alertBarUtils';

import type { IHeader } from '@klaviyo-mkt/components/organisms/header/types';
import type { IUniversalMenuItemWithCustomFields } from '@klaviyo-mkt/components/shared/types';

interface IStatefulSiteHeaderWithAlertBar
  extends Omit<IHeader, 'academyLoggedIn' | 'alertBar'> {
  ctasLoggedIn?: IHeader['universalCtas'];
  locale?: string;
  onResourcePage: boolean;
  partnerNavigationItems?: IUniversalMenuItemWithCustomFields[];
}

export const StatefulSiteHeaderWithAlertBar = ({
  ctasLoggedIn,
  locale,
  universalCtas,
  onResourcePage,
  path,
  universalNavigationItems,
  partnerNavigationItems,
  ...props
}: IStatefulSiteHeaderWithAlertBar) => {
  const hasClientRendered = useIsHydrated();
  const loggedIn = useStore($loggedIn);
  const isPartner = useStore($isPartner);
  const lastViewedResource = useStore($lastViewedResource);
  const lastViewedCollection = useStore($lastViewedCollection);

  const alertBar = getAlertBarConfig({
    hasClientRendered,
    locale,
    loggedIn,
    onResourcePage,
    lastViewedResource,
    lastViewedCollection,
    path
  });

  const academyProfileHref = usePartnerProfileUrl();

  // Use partner navigation if user is a partner and we have partner nav items
  const navigationItems = hasClientRendered && isPartner && partnerNavigationItems && partnerNavigationItems.length > 0
    ? partnerNavigationItems
    : universalNavigationItems;

  return (
    <Header
      {...props}
      academyLoggedIn={hasClientRendered ? (loggedIn ?? false) : undefined}
      academyProfileHref={academyProfileHref}
      universalCtas={hasClientRendered ? universalCtas : undefined}
      universalNavigationItems={navigationItems}
      alertBar={alertBar}
      path={path}
    />
  );
};
